import { gql, useMutation } from '@apollo/client';

import { useDataProvider } from '@work4all/data';

import { DevExpressReportSettings } from '@work4all/models/lib/Classes/DevExpressReportSettings.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

const req: DataRequest = {
  data: {
    logo1Url: null,
    logo2Url: null,
    footerHtml: null,
    addressLineOverride: null,
    logo1PosX: null,
    logo1PosY: null,
    logo2PosX: null,
    logo2PosY: null,
  } as DevExpressReportSettings,
  entity: Entities.devExpressReportSettings,
  completeDataResponse: true,
};

const UPSERT_REPORT_SETTINGS = gql`
  mutation upsertReportSettings(
    $logo1: ID
    $logo2: ID
    $footerHtml: String
    $addressLineOverride: String
    $logo1PosX: Decimal
    $logo1PosY: Decimal
    $logo2PosX: Decimal
    $logo2PosY: Decimal
  ) {
    upsertReportSettings(
      settings: {
        setLogo1: $logo1
        setLogo2: $logo2
        setFooterHtml: $footerHtml
        setAddressLineOverride: $addressLineOverride
        logo1PosX: $logo1PosX
        logo1PosY: $logo1PosY
        logo2PosX: $logo2PosX
        logo2PosY: $logo2PosY
      }
    ) {
      logo1Url
      logo2Url
      footerHtml
      addressLineOverride
      logo1PosX
      logo1PosY
      logo2PosX
      logo2PosY
    }
  }
`;

type UpsertReportSettingsVars = {
  logo1?: string;
  logo2?: string;
  footerHtml?: string;
  addressLineOverride?: string;
  logo1PosX?: number;
  logo1PosY?: number;
  logo2PosX?: number;
  logo2PosY?: number;
};

export const useDevExpressReportSettings = () => {
  const res = useDataProvider<DevExpressReportSettings>(req);

  const [mutate] = useMutation<
    DevExpressReportSettings,
    UpsertReportSettingsVars
  >(UPSERT_REPORT_SETTINGS, {
    context: { batch: false },
  });

  return {
    mutate,
    res: { ...res, data: res.data as DevExpressReportSettings },
  };
};
